import { nativeExtensionsListWithSettings } from '../constants/extension';
import { AvailableFor } from '../../marketplace-admin/constants';
export const isAngularExtensionInstalled = (extension, institution) => Boolean((institution?.institutionAccess ?? [])[`extensions_${extension.name}`]);
export const isNativeAvailableForProAndClinic = (extension, user, institution) => !extension.isInstalled &&
    nativeExtensionsListWithSettings.includes(extension.name) &&
    extension.availableFor === AvailableFor.PRO_CLINIC &&
    user.subscriptionType !== 'free' &&
    !institution;
export const isExtensionInstalled = (extension, user, institution) => Boolean(extension.isInstalled) ||
    isAngularExtensionInstalled(extension, institution) ||
    isNativeAvailableForProAndClinic(extension, user, institution);
const SETTINGS_NOT_AVAILABLE_FOR_PRO = new Set(['teleconsent']);
export const shouldHideExtensionSettinsForNotClinic = (extention, institution) => {
    return (SETTINGS_NOT_AVAILABLE_FOR_PRO.has(extention.name) && !Boolean(institution));
};
